module.exports = __webpack_public_path__ + "media/product_wearable_clean.84e76af6.mp4";